module.exports = __webpack_public_path__ + "img/dianzhi.871c449e.png";